import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Wlingua from 'assets/Wlingua.svg';
import { LeftMenuNav } from 'components/LeftMenuNav';
import React, { useState } from 'react';
import styled from 'styled-components';

const WIDTH_OPEN = 230;
const WIDTH_CLOSE = 18;

export const LeftMenu: React.FC = () => {
  const [folded, setFolded] = useState(false);
  return (
    <Left style={{ width: folded ? WIDTH_CLOSE : WIDTH_OPEN }}>
      {!folded && (
        <>
          <Header>
            <Logo src={Wlingua} alt="Logo" />
            <CollapseButton onClick={() => setFolded(!folded)}>
              <FontAwesomeIcon icon={faAngleDoubleLeft} />
            </CollapseButton>
          </Header>
          <LeftMenuNav />
        </>
      )}
      {folded && (
        <ExpandButton onClick={() => setFolded(!folded)}>
          <FontAwesomeIcon icon={faAngleDoubleRight} />
        </ExpandButton>
      )}
    </Left>
  );
};

const Left = styled.div`
  display: flex;
  flex-direction: column;
  background: #1a1f2e;
  overflow: visible;
  position: relative;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
  transition: width 0.3s ease;
`;

const Header = styled.div`
  position: relative;
  padding: 20px 12px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  margin-bottom: 12px;
`;

const Logo = styled.img`
  width: 130px;
  height: 36px;
  display: block;
  margin: 0 auto;
  opacity: 0.85;
  filter: brightness(1.1);
`;

const CollapseButton = styled.button`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  svg {
    font-size: 14px;
  }

  &:hover {
    color: #a8b0c4;
    background: rgba(255, 255, 255, 0.05);
  }
`;

const ExpandButton = styled.button`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  border: none;
  color: #8b92a8;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  svg {
    font-size: 12px;
  }

  &:hover {
    color: #c8cdd8;
  }
`;
